import { buildCrudRoutes } from 'Arch/components/crud/CrudRouter';

const featureBreadcrumb = [
  {
    text: 'Dashboard',
    disabled: false,
    to: 'dashboard',
  },
  {
    text: 'Usuários',
    disabled: false,
    to: 'users.list',
  },
];

export default [
  ...buildCrudRoutes({
    baseName: 'users',
    basePath: 'users',
    baseBreadcrumbs: featureBreadcrumb,
    listRoute: {
      pageContent: () => import('App/users/UserList.vue'),
      searchComponent: () => import('App/users/components/list/UserSearchList.vue'),
      filterComponent: () => import('App/users/components/filters/UserClientIdsFilter.vue'),
      reportComponent: () => import('App/users/components/modals/UsersReportButton.vue'),
      speedFilter: () => import('App/users/components/modals/UserBallanceReportButton.vue'),
      searchOptions: { label: 'Buscar usuário', searchAttribute: 'search' },
      navigateBackRoute: 'dashboard',
      pageTitle: 'Usuários',
    },
    editRoute: {
      component: () => import('App/users/UserForm.vue'),
      breadcrumbs: [
        {
          text: 'Visualizar detalhes',
          disabled: true,
        },
      ],
    },
  }),
];
